HGW.shippingCart = {

  lock: false,

  isShippingFeeItem(item) {
      return item?.properties?._hgw_shipping === "true";
    },

  buildCartSignature(cart) {
    return (cart?.items || [])
      .filter(item => item?.properties?._hgw_shipping !== "true")
      .map(item => `${item.variant_id}:${item.quantity}`)
      .sort()
      .join('|');
  },

  async addShippingFee(state) {

    if (HGW.shippingCart.lock) {
      console.warn("[HGW] shippingCart locked");
      return;
    }

    HGW.shippingCart.lock = true;

    try {
      if (!state || state.method !== "delivery") {
        await HGW.shippingCart.removeShippingFee();
        return;
      }

      const d = state.delivery || {};
      const parcel = Number(d.parcel_count || 0);
      const signature = Boolean(d.signature_required);

      if (!parcel) return;

      const variantId = signature
        ? HGW_CONFIG.shippingFeeVariants.aramex_metro.signature[parcel]
        : HGW_CONFIG.shippingFeeVariants.aramex_metro.no_signature[parcel];

      if (!variantId) {
        throw new Error("Shipping variant not found");
      }

      const cart = await fetch("/cart.js").then(r => r.json());
      const cartSig = HGW.shippingCart.buildCartSignature(cart);

      const existingShippingItem = (cart.items || []).find(item =>
        HGW.shippingCart.isShippingFeeItem(item)
      );

      const expectedSignature = signature ? "Yes" : "No";
      const expectedProvider = String(d.provider || "");
      const expectedParcel = String(parcel);
      const expectedDispatchDate = String(d.dispatch_date || "");
      const expectedVariantId = Number(variantId);

      const existingVariantId = Number(existingShippingItem?.variant_id || 0);
      const existingProps = existingShippingItem?.properties || {};

      const alreadyValid =
        existingShippingItem &&
        existingVariantId === expectedVariantId &&
        existingProps._hgw_cart_sig === cartSig &&
        String(existingProps.provider || "") === expectedProvider &&
        String(existingProps.parcel_count || "") === expectedParcel &&
        String(existingProps.signature || "") === expectedSignature &&
        String(existingProps.dispatch_date || "") === expectedDispatchDate;

      if (alreadyValid) {
        console.log("[HGW] shipping fee already valid, skip sync");
        return;
      }

      /* -----------------------------
        기존 배송비 제거
      ----------------------------- */

      await HGW.shippingCart.removeShippingFee(cart);

      /* -----------------------------
        새 배송비 추가
      ----------------------------- */

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: {
                _hgw_shipping: "true",
                _hgw_cart_sig: cartSig,
                provider: String(d.provider || ""),
                parcel_count: String(parcel),
                signature: signature ? "Yes" : "No",
                dispatch_date: String(d.dispatch_date || "")
              }
            }
          ]
        })
      });

      if (!addRes.ok) {
        throw new Error(`cart/add.js failed: ${addRes.status}`);
      }

      console.log("[HGW] shipping fee added");
    } catch (err) {
      console.error("[HGW] addShippingFee error", err);
    } finally {
      HGW.shippingCart.lock = false;
    }
  }
};

/* =====================================
배송비 제거
===================================== */

HGW.shippingCart.removeShippingFee = async function (cartArg = null) {
  try {
    const cart = cartArg || await fetch("/cart.js").then(r => r.json());
    let removed = false;

    for (const item of (cart.items || [])) {
      if (HGW.shippingCart.isShippingFeeItem(item)) {
        removed = true;

        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
      }
    }

    return removed;
  } catch (err) {
    console.error("[HGW] removeShippingFee error", err);
    return false;
  }
};